import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import "./Home.css";

const FounderMessage = () => {
  return (
    <section className="backdiv">
      
          <h2 className="main-title">
            A Vision That Inspires<br/>
            Innovation
          </h2>

        <div className="founder-card">

          <div className="quote-circle">
            <FaQuoteLeft />
          </div>

          <div>

            <p className="founder-text">
              Every meaningful innovation begins with a vision.
            <br/>

              Throughout our professional journey, we have always believed that
              technology should empower people, simplify businesses, and create
              opportunities that extend far beyond today's challenges.<br/>
           
              VedAstra was founded with the ambition of building more than an IT
              company. It was created to become a trusted innovation partner for
              businesses seeking sustainable growth through intelligent
              technology.
          
              Our approach is rooted in continuous learning, future-focused
              thinking, and a deep understanding of how business, technology,
              education, and emerging global trends intersect.<br/>
            
              At VedAstra, we believe innovation is not about keeping pace with
              change—it is about anticipating it.
        
              As we continue this journey, our commitment remains unchanged: to
              build solutions with integrity, lead with purpose, and create
              lasting value for every organization we serve.
            </p>

            <div className="signature">

              <div className="signature-line"></div>

              <h4>Vedastra Leadership</h4>

            </div>

          </div>

        </div>


    </section>
  );
};

export default FounderMessage;